export const SUP_CELL_THERAPY_CALCULATORS_LOADER = {
  desktop: `
<div class="cui-grid cui-container">
  <div class="cui-skeleton-paragraph -spacing--top-64 -spacing--bottom-40">
    <div class="cui-skeleton-paragraph__content" style="width: 170px">
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-40">
    <div class="cui-skeleton-heading__content">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="-spacing--bottom-24" style="display: flex; gap: 24px">
    <div class="cui-skeleton__item" style="width: 160px; height: 16px; display: inline-block;"></div>
    <div class="cui-skeleton__item" style="width: 160px; height: 16px; display: inline-block;"></div>
    <div class="cui-skeleton__item" style="width: 160px; height: 16px; display: inline-block;"></div>
    <div class="cui-skeleton__item" style="width: 160px; height: 16px; display: inline-block;"></div>
  </div>
  <div class="-spacing--bottom-40 cui-skeleton__item" style="width: 100%; height: 2px; display: block;"></div>
  <div class="cui-row">
    <div class="cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-paragraph -spacing--bottom-16">
        <div class="cui-skeleton-paragraph__content" style="width: 100%">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph__content -spacing--bottom-32" style="width: 100%;">
        <div class="cui-skeleton__item -spacing--bottom-4" style="height: 48px;"></div>
        <div class="cui-skeleton__item -spacing--bottom-4" style="height: 48px;"></div>
        <div class="cui-skeleton__item -spacing--bottom-4" style="height: 48px;"></div>
        <div class="cui-skeleton__item -spacing--bottom-4" style="height: 48px;"></div>
      </div>
      <div class="cui-skeleton-button -size--large" style="display: flex; justify-content: end;">
        <div class="cui-skeleton-button__content" style="width: 120px;">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
    </div>
    <div class="cui-col-md-4 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block" style="margin-top: 34px;">
        <div class="cui-skeleton__item" style="width: 100%; height: 228px;"></div>
      </div>
    </div>
  </div>
</div>
`
};
